//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/index'
import ListLoading from '@/components/views/loading'
import CommentTip from '@/views/building/_components/comment_tip'

import add_comments from '@/common/mixins/addComments'

import CommentItem from '@/views/building/comments/_item'

import { errorLog } from '@/utils/log'
import { App_User } from '@/data/user_info'
export default {
    mixins: [
        add_comments
    ],
    data () {
        return {
            comments: [],
            comment_count: 0,
            loading: true
        }
    },
    methods: {
        getData (building_id) {
            Service.getBuildingComments(building_id, {
                per: 3,
                page: 1
            }).then(data => {
                this.comments = data.items.splice(0, 3)
                this.comment_count = data.comment_count
                this.loading = false
            }).catch((err) => {
                errorLog(`get building comments error ${JSON.stringify(err)}, options: ${JSON.stringify(this.$route.query)}`)
            })
        },
        goAllComments (e) {
            this.$emit('goComments')
        },
        addComment (e) {
            App_User.fetchUser().then((user) => {
                if (user.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                } else {
                    const { building_id } = this.$route.query
                    this.goAddComment(building_id).then((can_comment) => {
                        can_comment && this.$emit('goAdd')
                    })
                }
            })
        },
        changeComment (comment, index) {
            const changed_item = this.comments[index]
            if (comment.id === changed_item.id) {
                this.$set(this.comments, index, comment)
            } else {
                this.comments.some(({ id }, real_index) => {
                    if (id === comment.id) {
                        this.$set(this.comments, real_index, comment)
                        return true
                    }
                })
            }
        }
    },
    props: {
        is_vip: {
            type: Boolean
        }
    },
    components: {
        ListLoading,
        CommentTip,
        CommentItem
    }
}
